import { ComponentFactoryResolver, ComponentRef, Directive, Input, OnChanges, OnInit, Type, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { FormButtonComponent } from '../form-button/form-button.component';
import { FormInputComponent } from '../form-input/form-input.component';
import { FormSelectComponent } from '../form-select/form-select.component';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { FormtoggleComponent } from '../form-toggle/form-toggle.component';
import { FormdateComponent } from '../form-date/form-date.component';
import { FormTextareaComponent } from '../form-textarea/form-textarea.component';
import { FormNumberComponent } from '../form-number/form-number.component';
import { ResetbuttonComponent } from '../form-reset-button/form-reset-button.component';
import { FormInputAutocompleteComponent } from '../form-input-autocomplete/form-input-autocomplete.component';
import { FormAutocompleteComponent } from '../form-autocomplete/form-autocomplete.component';
import { AutoSyncComponent } from '../auto-sync/auto-sync.component';
import { ContentComponent } from '../content/content.component';
import { FormRadioComponent } from '../form-radio/form-radio.component';
import { LabelTextComponent } from '../label-text/label-text.component';
import { FormDateRangeComponent } from '../form-date-range/form-date-range.component';



const components: {[type: string]: Type<Field>} = {
  button: FormButtonComponent,
  input: FormInputComponent,
  select: FormSelectComponent,
  toggle: FormtoggleComponent,
  date: FormdateComponent,
  textarea: FormTextareaComponent,
  number: FormNumberComponent,
  reset: ResetbuttonComponent,
  inputAutoComplete: FormInputAutocompleteComponent,
  autocomplete: FormAutocompleteComponent,
  manualSync: AutoSyncComponent,
  content: ContentComponent,
  radio: FormRadioComponent,
  label: LabelTextComponent,
  daterange: FormDateRangeComponent
};

@Directive({ selector: '[dynamicField]' })
export class DynamicFieldDirective implements Field, OnChanges, OnInit {
  @Input()
  config: FieldConfig;

  @Input()
  group: FormGroup;

  component: ComponentRef<Field>;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {
  }

  ngOnChanges() {
    if (this.component) {
      this.component.instance.config = this.config;
      this.component.instance.group = this.group;
    }
  }

  ngOnInit() {
    if (!components[this.config.type]) {
      const supportedTypes = Object.keys(components).join(', ');
      throw new Error(
        `Trying to use an unsupported type (${this.config.type}).
        Supported types: ${supportedTypes}`
      );
    }
    const component = this.resolver.resolveComponentFactory<Field>(components[this.config.type]);
    this.component = this.container.createComponent(component);
    this.component.instance.config = this.config;
    this.component.instance.group = this.group;
  }
}
